(function () {
  'use strict';

  var LEGACY_NOINDEX = /(?:^|\s)-tag:NOINDEX\b/i;

  function isSearchPage() {
    return window.location.pathname.indexOf('/search') !== -1;
  }

  function getSearchParams() {
    return new URLSearchParams(window.location.search);
  }

  function getVisiblePage() {
    var page = parseInt(getSearchParams().get('visible_page') || '1', 10);
    return page > 0 ? page : 1;
  }

  function buildSearchPageUrl(page) {
    var params = getSearchParams();
    params.delete('page');
    if (page <= 1) {
      params.delete('visible_page');
    } else {
      params.set('visible_page', String(page));
    }
    var qs = params.toString();
    return window.location.pathname + (qs ? '?' + qs : '');
  }

  function fixLegacyUrl() {
    if (!isSearchPage()) return;

    var params = getSearchParams();
    var q = params.get('q');
    var changed = false;

    if (q && LEGACY_NOINDEX.test(q)) {
      params.set('q', q.replace(/(?:^|\s)-tag:NOINDEX\b/gi, '').trim());
      changed = true;
    }

    if (params.has('page') && !params.has('visible_page')) {
      var legacyPage = parseInt(params.get('page'), 10);
      if (legacyPage > 1) params.set('visible_page', String(legacyPage));
      params.delete('page');
      changed = true;
    }

    if (!changed) return;
    window.location.replace(window.location.pathname + '?' + params.toString() + window.location.hash);
  }

  function getPaginationParts(current, total) {
    var windowSize = 2;

    if (total <= 7) {
      return Array.from({ length: total }, function (_, i) {
        return i + 1;
      });
    }

    var start = Math.max(2, current - windowSize);
    var end = Math.min(total - 1, current + windowSize);
    var pages = [1];
    var prev = 1;

    for (var p = start; p <= end; p++) {
      if (p > prev + 1) pages.push('…');
      pages.push(p);
      prev = p;
    }

    if (total > prev + 1) pages.push('…');
    if (total !== prev) pages.push(total);

    return pages;
  }

  function createPageElement(part, currentPage) {
    var span = document.createElement('span');
    span.className = 'page';

    if (part === '…') {
      span.textContent = '…';
      return span;
    }

    if (part === currentPage) {
      span.classList.add('current');
      span.textContent = String(part);
      return span;
    }

    var link = document.createElement('a');
    link.href = buildSearchPageUrl(part);
    link.textContent = String(part);
    span.appendChild(link);
    return span;
  }

  function renderPagination(pagination, currentPage, totalPages) {
    var nav = pagination.querySelector('.page-numbers');
    var next = pagination.querySelector('.next');
    if (!nav || !next) return;

    nav.querySelectorAll('.page').forEach(function (el) {
      el.remove();
    });

    getPaginationParts(currentPage, totalPages).forEach(function (part) {
      nav.insertBefore(createPageElement(part, currentPage), next);
    });

    var prevLink = pagination.querySelector('[data-search-page-link="prev"]');
    var nextLink = pagination.querySelector('[data-search-page-link="next"]');

    if (prevLink) {
      prevLink.href = currentPage > 1 ? buildSearchPageUrl(currentPage - 1) : '#';
      prevLink.toggleAttribute('disabled', currentPage <= 1);
    }

    if (nextLink) {
      nextLink.href = currentPage < totalPages ? buildSearchPageUrl(currentPage + 1) : '#';
      nextLink.toggleAttribute('disabled', currentPage >= totalPages);
    }
  }

  function applySearchPage() {
    if (!isSearchPage()) return;

    var grid = document.querySelector('#product-grid[data-search-pagination]');
    if (!grid) return;

    var totalPages = parseInt(grid.dataset.searchTotalPages || '1', 10) || 1;
    var currentPage = Math.min(Math.max(getVisiblePage(), 1), totalPages);

    var header = document.querySelector('.template-header--description');
    if (header && grid.dataset.searchResultsLabel) {
      header.textContent = grid.dataset.searchResultsLabel;
    }

    grid.querySelectorAll('[data-search-page]').forEach(function (item) {
      item.hidden = parseInt(item.dataset.searchPage, 10) !== currentPage;
    });

    var pagination = document.querySelector('.search-pagination');
    if (pagination) renderPagination(pagination, currentPage, totalPages);
  }

  fixLegacyUrl();
  applySearchPage();
  window.addEventListener('pageshow', applySearchPage);
})();
